import { render, staticRenderFns } from "./SetTeamAllocationSettings.vue?vue&type=template&id=5ecb1d2a&scoped=true"
import script from "./SetTeamAllocationSettings.vue?vue&type=script&lang=ts"
export * from "./SetTeamAllocationSettings.vue?vue&type=script&lang=ts"
import style0 from "./SetTeamAllocationSettings.vue?vue&type=style&index=0&id=5ecb1d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb1d2a",
  null
  
)

export default component.exports